export default {
    periods: state => state.periods,
    activePeriod: state => state.activePeriod,
    managePeriodDialog: state => state.managePeriodDialog,
    deletePeriodDialog: state => state.deletePeriodDialog
}
